import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ChangePasswordModal from '../Common Modals/changepassword';

const PasswordChangeGate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const userId = typeof window !== 'undefined' ? localStorage.getItem('userId') : null;
  const userRole = typeof window !== 'undefined' ? localStorage.getItem('userRole') : null;
  const mustChangePassword = typeof window !== 'undefined' ? localStorage.getItem('mustChangePassword') === 'true' : false;

  const nextRoute = useMemo(() => {
    return location.state?.nextRoute || localStorage.getItem('postPasswordChangeRoute') || '/signin';
  }, [location.state]);

  useEffect(() => {
    if (!token) {
      navigate('/signin', { replace: true });
    }
  }, [token, navigate]);

  const handleSuccess = () => {
    localStorage.removeItem('mustChangePassword');
    localStorage.removeItem('passwordChangeReason');
    localStorage.removeItem('postPasswordChangeRoute');
    navigate(nextRoute, { replace: true, state: location.state || {} });
  };

  if (!token || !userId) {
    return null;
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-8">
      <ChangePasswordModal
        isOpen={true}
        onClose={() => {}}
        userId={userId}
        userRole={userRole || 'user'}
        isForced={mustChangePassword}
        onSuccess={handleSuccess}
      />
    </div>
  );
};

export default PasswordChangeGate;
